<script>
import Titre from "@/components/atoms/titre";
import FideliteMerchNew from "@/components/organisms/fidelite-merch/new";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Card from "@/components/molecules/card";
import Badge from "@/components/atoms/badge";
import Divider from "@/components/atoms/divider";
import Container from "@/components/atoms/container";
import FideliteMerchEurocora from "@/components/organisms/fidelite-merch/eurocora";
import FideliteMerchProspectus from "@/components/organisms/fidelite-merch/prospectus";
import FideliteMerchDefis from "@/components/organisms/fidelite-merch/defis";
import FideliteCarteInfo from "@/containers/fidelite-carte-info";
import ButtonIcon from "@/components/molecules/button-icon";
import Breadcrumbs from "@/components/molecules/breadcrumbs/default";
import DefiCardOverview from "@/containers/defi-card-overview";
import { useContainerFidelite } from "@/containers/mixin/fidelite.mixin";
import dateUtil from "@/utils/date.js";
import CartesFideliteComparatif from "@/containers/cartes-fidelite-comparatif";
import FideliteMerchPoints from "@/components/organisms/fidelite-merch/points";
import FideliteMerchCards from "@/components/organisms/fidelite-merch/cards";
import Popin from "@/containers/popin-adaptive";

import { mapState } from "pinia";
import { useClientStore } from "@/store/client";
import { useAuthStore } from "@/store/auth";

import illuCagnottage from "@/assets/images/illustration-fidelite-cora-cagnottage-2.svg";
import fidEtape1 from "@/assets/images/fid-ccm-etape-1.svg";
import fidEtape2 from "@/assets/images/fid-ccm-etape-2.svg";
import fidEtape4 from "@/assets/images/fid-ccm-etape-4.svg";
import fidEtape5 from "@/assets/images/fid-ccm-etape-5.svg";
import fidEtape6 from "@/assets/images/fid-ccm-etape-6.svg";

export default {
  name: "AccueilFidelite",
  components: {
    FideliteMerchNew,
    Button,
    LazyImage,
    Titre,
    Card,
    Badge,
    Divider,
    Container,
    FideliteMerchEurocora,
    FideliteMerchProspectus,
    FideliteMerchDefis,
    FideliteCarteInfo,
    ButtonIcon,
    Breadcrumbs,
    DefiCardOverview,
    CartesFideliteComparatif,
    FideliteMerchPoints,
    FideliteMerchCards,
    Popin
  },
  props: {
    cartes: {
      type: Array,
      required: false,
      default: () => []
    },
    isMonCompte: {
      type: Boolean,
      required: false,
      default: false
    },
    alertFid: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup(props) {
    const { setPopinAjoutCarte } = useContainerFidelite();

    const { defisEncours } = storeToRefs(useClientStore());

    const typeCarte = computed(() => {
      return props.cartes.length === 1
        ? props.cartes[0].attributes.type_carte
        : "anonyme";
    });
    const defis = computed(() => {
      return defisEncours.value(typeCarte.value);
    });

    return {
      setPopinAjoutCarte,
      illuCagnottage,
      fidEtape1,
      fidEtape2,
      fidEtape4,
      fidEtape5,
      fidEtape6,
      typeCarte,
      defis
    };
  },
  methods: {
    back() {
      this.$router.back();
    }
  },
  data() {
    return {
      breadcrumbs: [{ text: "Programme de fidélité", route: { link: "#" } }]
    };
  },
  computed: {
    ...mapState(useClientStore, ["isAbonneLad", "defisEncours", "defisAVenir"]),
    ...mapState(useAuthStore, ["isLogged"]),
    showBandeauNew() {
      const today = new Date();
      return (
        today <=
          dateUtil.toDate(
            useRuntimeConfig().public.NOUVELLE_FIDELITE_END_DATE_BANDEAU_NEW
          ) &&
        today >=
          dateUtil.toDate(
            useRuntimeConfig().public.NOUVELLE_FIDELITE_START_DATE_BANDEAU_NEW
          )
      );
    }
  }
};
</script>

<template>
  <div class="c-fidelite-accueil">
    <div
      v-if="!isMonCompte"
      class="u-bgcolor-white"
    >
      <Breadcrumbs
        :breadcrumbs="breadcrumbs"
        class="u-mr-sm u-ml-sm u-none@md"
      />
      <Container>
        <ButtonIcon
          icon-name="arrow-left"
          icon-color="text"
          icon-color-hover="primary-light"
          text-hover-color="primary-light"
          class="u-mt-sm"
          size="xs"
          @click="back()"
        >
          Retour
        </ButtonIcon>
      </Container>
    </div>
    <Popin
      ref="showCartesComparatif"
      size="lg"
      page-back
      page
    >
      <Titre
        tag="h2"
        variant="primary"
        size="md"
        class="u-mb-lg20 u-text-center"
      >
        Choisissez la carte qui vous convient
      </Titre>
      <CartesFideliteComparatif />
    </Popin>
    <div
      v-if="showBandeauNew"
      class="c-fidelite-accueil__alert-new u-pt-xs"
    >
      <FideliteMerchNew />
    </div>
    <div class="c-fidelite-accueil__cover-wrapper">
      <div class="c-fidelite-accueil__cover">
        <div class="c-fidelite-accueil__cover-content">
          <LazyImage
            :src="illuCagnottage"
            width="346"
            alt=""
            class="c-fidelite-accueil__cover-img"
          />
          <div class="c-fidelite-accueil__cover-text">
            <h2 class="u-font-secondary u-font-32 u-font-28@md u-font-700">
              Découvrez le programme fidélité
            </h2>
          </div>
          <div class="c-fidelite-accueil__cover-buttons">
            <template v-if="cartes.length === 0">
              <Button
                size="lg"
                radius="full"
                variant="primary"
                @click="setPopinAjoutCarte()"
              >
                J’enregistre ma carte
              </Button>

              <Button
                size="lg"
                radius="full"
                variant="primary"
                outline
                to="/creation-carte-fidelite"
              >
                Je crée ma carte gratuitement
              </Button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="c-fidelite-accueil__avantage-wrapper">
      <div
        v-if="cartes.length > 0"
        class="u-mt-lg u-mb-xlg"
      >
        <Card
          v-for="carte in cartes"
          :key="carte.id"
          radius="lg"
          border-color="border"
          class="u-border-none@md"
        >
          <FideliteCarteInfo
            :carte="carte"
            class="u-p-sm u-px-sm@md"
          />
        </Card>
        <div class="u-text-center u-mt-md u-mt-none@md">
          <Button
            size="lg"
            radius="full"
            variant="primary"
            to="/mon-compte/ma-fidelite"
          >
            <p class="u-px-md u-py-xs">
              Mon espace de fidélité
            </p>
          </Button>
        </div>
      </div>

      <div class="u-mb-xlg u-mb-lg@md u-mx-sm">
        <Titre
          tag="h2"
          variant="primary"
          size="md"
          class="u-mb-lg u-text-center u-text-left@md"
        >
          Cumulez des points à chaque achat
        </Titre>
        <FideliteMerchPoints />
      </div>
      <div class="u-mb-xlg u-mb-lg@md u-mx-sm">
        <Titre
          tag="h2"
          variant="primary"
          size="md"
          class="u-mb-lg u-text-center u-text-left@md"
        >
          Cumulez des €urocora toute l’année grâce aux prospectus
        </Titre>
        <FideliteMerchEurocora
          radius="md"
          border-color="grey-5"
          class="u-mb-md"
        />
        <FideliteMerchProspectus
          radius="md"
          border-color="grey-5"
        />
      </div>
      <div
        v-if="cartes.length === 0"
        class="u-flex u-flex-column u-flex-align-center u-mx-sm"
      >
        <Titre
          tag="h2"
          variant="primary"
          size="md"
          class="u-mb-lg20 u-text-center u-text-left@md"
        >
          Choisissez la carte qui vous convient
        </Titre>

        <div class="u-flex u-flex-justify-center u-flex-wrap u-gap-column-lg u-gap-row-sm">
          <FideliteMerchCards card="malin" />
          <FideliteMerchCards card="cora" />
        </div>

        <Button
          size="sm"
          radius="full"
          variant="primary"
          outline
          class="u-mt-lg"
          @click="$refs.showCartesComparatif.show()"
        >
          Voir le comparatif des avantages
        </Button>
      </div>
    </div>

    <div class="u-bgcolor-bg u-py-xlg u-py-lg20@md">
      <div class="c-fidelite-accueil__ccm-wrapper">
        <Titre
          tag="h2"
          variant="primary"
          size="lg"
          class="u-text-center u-mb-md"
        >
          Votre fidélité<br>
          Comment ça marche ?
        </Titre>
        <div class="c-fidelite-accueil__ccm-item-wrapper">
          <div class="c-fidelite-accueil__ccm-item">
            <div class="c-fidelite-accueil__ccm-text">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">1</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h3"
                  size="xs"
                  variant="primary"
                >
                  Je crée ma carte
                </Titre>
                <p class="u-mt-xxs">
                  Directement sur cora.fr, en me rendant aux caisses ou bien au Village Des Services de mon magasin pour ouvrir ma carte
                </p>
              </div>
            </div>
            <LazyImage
              :src="fidEtape1"
              width="252"
              class="c-fidelite-accueil__ccm-image u-flex-item-none"
            />
          </div>

          <Divider
            dotted
            class="u-my-lg"
          />

          <div class="c-fidelite-accueil__ccm-item c-fidelite-accueil__ccm-item--reverse">
            <div class="c-fidelite-accueil__ccm-image">
              <LazyImage
                :src="fidEtape2"
                width="252"
                class="c-fidelite-accueil__ccm-image u-flex-item-none"
              />
            </div>
            <div class="c-fidelite-accueil__ccm-text">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">2</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h3"
                  size="xs"
                  variant="primary"
                >
                  Je reçois ma carte dématérialisée dans ma boite email
                </Titre>
                <p class="u-mt-xxs">
                  Je peux aussi l'obtenir en magasin et l'enregistrer sur mon appli Wallet préférée (Apple Wallet ou Google Wallet)
                </p>
              </div>
            </div>
          </div>

          <Divider
            dotted
            class="u-my-lg"
          />

          <div class="c-fidelite-accueil__ccm-item">
            <div class="c-fidelite-accueil__ccm-text">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">3</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h3"
                  size="xs"
                  variant="primary"
                >
                  Je cumule des €urocora et des points au quotidien en magasin et sur cora.fr
                </Titre>
                <p class="u-mt-xxs">
                  Je présente ma carte à chaque passage en caisse ou je la renseigne dans mon compte client cora.fr pour mes achats en ligne
                </p>
              </div>
            </div>
            <LazyImage
              :src="illuCagnottage"
              width="252"
              class="c-fidelite-accueil__ccm-image u-flex-item-none"
            />
          </div>
          <Divider
            dotted
            class="u-my-lg"
          />
          <div class="c-fidelite-accueil__ccm-item c-fidelite-accueil__ccm-item--reverse">
            <div class="c-fidelite-accueil__ccm-image">
              <LazyImage
                :src="fidEtape4"
                width="252"
                class="c-fidelite-accueil__ccm-image u-flex-item-none"
              />
            </div>

            <div class="c-fidelite-accueil__ccm-text">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">4</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h3"
                  size="xs"
                  variant="primary"
                >
                  Je suis l'évolution de ma cagnotte
                </Titre>
                <p class="u-mt-xxs">
                  Je consulte les €urocora et les points cagnottés depuis mon compte client cora.fr
                </p>
              </div>
            </div>
          </div>

          <Divider
            dotted
            class="u-my-lg"
          />

          <div class="c-fidelite-accueil__ccm-item">
            <div class="c-fidelite-accueil__ccm-text">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">5</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h3"
                  size="xs"
                  variant="primary"
                >
                  Je m'inscris chaque mois à des défis pour cumuler encore plus d'€urocora
                </Titre>
                <p class="u-mt-xxs">
                  Je découvre chaque mois les nouveaux défis proposés
                </p>
              </div>
            </div>
            <div class="c-fidelite-accueil__ccm-image">
              <LazyImage
                :src="fidEtape5"
                width="252"
                class="c-fidelite-accueil__ccm-image u-flex-item-none"
              />
            </div>
          </div>

          <Divider
            dotted
            class="u-my-lg"
          />
          <div class="c-fidelite-accueil__ccm-item c-fidelite-accueil__ccm-item--reverse">
            <div class="c-fidelite-accueil__ccm-image">
              <LazyImage
                :src="fidEtape6"
                width="252"
                class="c-fidelite-accueil__ccm-image u-flex-item-none"
              />
            </div>
            <div class="c-fidelite-accueil__ccm-text">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">6</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h3"
                  size="xs"
                  variant="primary"
                >
                  J’utilise mes avantages
                </Titre>
                <p class="u-mt-xxs">
                  Je transforme mes points et je déduis mes €urocora lorsque je le souhaite, en magasin et sur cora.fr, avant le 31 décembre de chaque année
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="u-text-center u-mt-lg30">
          <Button
            size="lg"
            radius="full"
            variant="primary"
            to="/creation-carte-fidelite"
          >
            Enregistrer ou créer ma carte
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/fidelite-accueil.scss";
</style>
